import { defineMessages, useIntl } from 'react-intl';

import { format } from 'date-fns/format';
import { isToday } from 'date-fns/isToday';
import { isTomorrow } from 'date-fns/isTomorrow';

/**
 * Returns either 'today', 'tomorrow' or 'M/d' for the date received.
 * Finally, it returns 'unknown' if the time is not available.
 */
export const useDayLabel = (time?: Date) => {
  const { formatMessage } = useIntl();

  if (!time) {
    return formatMessage(messages.unknown);
  }

  if (isToday(time)) {
    return formatMessage(messages.today);
  }

  if (isTomorrow(time)) {
    return formatMessage(messages.tomorrow);
  }

  return format(time, 'M/d');
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  unknown: {
    defaultMessage: 'unknown',
    description: 'Day Label | Unknown',
  },
  today: {
    defaultMessage: 'today',
    description: 'Day Label | Today',
  },
  tomorrow: {
    defaultMessage: 'tomorrow',
    description: 'Day Label | Tomorrow',
  },
});
